import React, { useCallback } from 'react';

import { i18n } from '../../../../../../shared/helpers/i18n';
import { countMetrika } from '../../../../../../shared/helpers/metrika';
import { useActions } from '../../../../../../shared/hooks';
import { startCloudRecordingAction } from '../../../../features/cloud-recording';
import { ToolbarOption } from '../../toolbar-option';

export function StartCloudRecordingOption() {
    const actions = useActions({ startCloudRecordingAction });
    const title = i18n('toolbar', 'cloud-recording-start');
    const onClick = useCallback(() => {
        actions.startCloudRecordingAction();
        countMetrika('meeting_screen', 'toolbar', 'cloud_recording_start');
    }, [actions]);

    return <ToolbarOption iconName="record" onClick={onClick} title={title} content={title} />;
}
